import React from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { DeliveryOpeningHoursBehaviour, DeliveryType } from 'common/types';
import { getDefaultOpeningHoursBehaviour } from 'common/modules/delivery/utils';
import { useTranslation } from 'services/localization';

export interface Props {
	value?: DeliveryOpeningHoursBehaviour;
	onChange?: (value: DeliveryOpeningHoursBehaviour) => void;
	type: DeliveryType;
}
const OpeningHoursBehaviour = (props: Props) => {
	const { t } = useTranslation();
	const { value = getDefaultOpeningHoursBehaviour(), onChange, type } = props;
	return (
		<Box>
			<FormGroup>
				<FormControlLabel
					onChange={(e, checked) => onChange?.({ ...value, allowStartOnClosedDays: checked })}
					control={<Checkbox checked={value.allowStartOnClosedDays ?? false} />}
					label={t(
						'delivery.allowDeliveryOnClosedDays',
						'Allow delivery on days when the store is closed',
					)}
				/>
				<FormControlLabel
					onChange={(e, checked) => onChange?.({ ...value, allowEndOnClosedDays: checked })}
					control={<Checkbox checked={value.allowEndOnClosedDays ?? false} />}
					label={
						type === 'DELIVERY_ONLY'
							? t(
									'delivery.allowSelfReturnOnClosedDays',
									'Allow self-return on days when the store is closed',
							  )
							: t(
									'delivery.allowSelfReturnAndPickupOnClosedDays',
									'Allow pickup and self-return on days when the store is closed',
							  )
					}
				/>
			</FormGroup>
		</Box>
	);
};

export default OpeningHoursBehaviour;
